import {
  Box,
  Grid,
  TextField,
  Button,
  TextareaAutosize,
} from "@material-ui/core";
import {
  AdminUpdateUserBodyParams,
  AdminUserDetailsResponse,
} from "@authory-packages/core";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import { Api } from "../lib/api";

type UserDataPanelProps = {
  userDetails?: AdminUserDetailsResponse;
  userSlug?: string;
  onDataSaved: (data: AdminUserDetailsResponse) => void;
};

export const UserDataPanel = ({
  userDetails,
  userSlug,
  onDataSaved,
}: UserDataPanelProps) => {
  const { enqueueSnackbar } = useSnackbar();

  const formik = useFormik({
    initialValues: {
      password: "",
      email: userDetails?.email || "",
      firstName: userDetails?.firstName || "",
      lastName: userDetails?.lastName || "",
      aliases: userDetails?.aliases ? userDetails?.aliases.join(";") : "",
      note: userDetails?.note || "",
    },
    onSubmit: async (data) => {
      if (!userSlug) return;

      const params = new AdminUpdateUserBodyParams();

      if (data.password.length) params.password = data.password;

      params.firstName = data.firstName;
      params.lastName = data.lastName;
      params.aliases = data.aliases.split(";");
      params.note = data.note;
      params.email = data.email;

      try {
        const updatedUser = await Api.saveUser(userSlug, params);
        onDataSaved(updatedUser.data);
        enqueueSnackbar("User saved!", { variant: "success" });
      } catch (error: any) {
        // variant could be success, error, warning, info, or default
        enqueueSnackbar(error.response.data.message, { variant: "error" });
      }
    },
    enableReinitialize: true,
  });

  return (
    <>
      <form noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label="Password"
              name="password"
              type="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              autoComplete="off"
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label="Firstname"
              name="firstName"
              value={formik.values.firstName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label="Lastname"
              name="lastName"
              value={formik.values.lastName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Aliases (Semicolon separated)"
              name="aliases"
              value={formik.values.aliases}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <TextareaAutosize
            rowsMin={10}
            placeholder="Notes"
            style={{
              width: "100%",
              marginTop: 20,
            }}
            name="note"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.note}
          />
        </Grid>
        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => formik.submitForm()}
          >
            Save
          </Button>
        </Box>
      </form>
    </>
  );
};
